import { LayoutType } from "components/ExtendedContent/ExtendedContentContainer/layout";
import { splitSynopsisIntoPages_PlainText } from "./strategies/splitForPlainText";
import { splitSynopsisIntoPages_Topic108_2 } from "./strategies/splitForTopic108_2";
import { splitSynopsisIntoPages_Simple108_2 } from "./strategies/splitForSimple108_2";
import { splitSynopsisIntoPages_Image108_2 } from "./strategies/splitForImage108_2";

/**
 * Per-style 切頁策略註冊表（ADR-0001 的 A 層）。
 *
 * 每個 strategy 的簽章統一為：
 *   (html, lineHeight, pageSize, referenceContainer) => { htmlString, totalPages }
 * 回傳值可以是同步物件或 Promise（PlainText / Simple 為 async，Topic 為同步）。
 *
 * Step 1（行為等價）階段，這裡直接沿用三個既有的 splitter，
 * 各 strategy 內部的測量邏輯維持不變。未來新增/調整某樣式的切頁規則，
 * 只需在此註冊或修改對應 strategy，不影響其他樣式與引擎入口。
 */
export const paginationStrategies = {
  [LayoutType.PlainText]: splitSynopsisIntoPages_PlainText,
  [LayoutType.Topic_108_2]: splitSynopsisIntoPages_Topic108_2,
  [LayoutType.Simple_108_2]: splitSynopsisIntoPages_Simple108_2,
  [LayoutType.Image_108_2]: splitSynopsisIntoPages_Image108_2,
};

/**
 * 取得指定 layout 的切頁策略，沒有註冊則回傳 null。
 * @param {string} layoutType
 * @returns {Function|null}
 */
export const getPaginationStrategy = (layoutType) =>
  paginationStrategies[layoutType] || null;
